var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.user
    ? _c(
        "div",
        { staticClass: "p-3" },
        [
          _c(
            "b-card",
            { attrs: { title: "Konfigurasi Kuota Poli" } },
            [
              _c("b-card-text", [
                _c(
                  "div",
                  { staticClass: "mt-5" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn-sm",
                        attrs: { variant: "primary" },
                        on: { click: _vm.addKuotaPoli },
                      },
                      [
                        _c("b-icon", { attrs: { icon: "plus" } }),
                        _vm._v(" Tambah Data"),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "b-modal",
                            rawName: "v-b-modal.modal-umum",
                            modifiers: { "modal-umum": true },
                          },
                        ],
                        staticClass: "btn-sm",
                        attrs: { variant: "primary" },
                        on: { click: _vm.getPoli },
                      },
                      [
                        _c("b-icon", { attrs: { icon: "plus" } }),
                        _vm._v(" Tambah Jadwal Umum"),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt-3 row" }, [
                      _c(
                        "label",
                        {
                          staticClass: "col-sm-2 col-form-label text-end",
                          attrs: { for: "poli-select" },
                        },
                        [_vm._v("Nama Poli")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-sm-4" },
                        [
                          _c("select2", {
                            staticClass: "form-input",
                            attrs: {
                              options: _vm.option_poli,
                              id: "poli-select",
                            },
                            on: { change: _vm.getKonfigurasiKuotaPoli },
                            model: {
                              value: _vm.search_data.nama_poli,
                              callback: function ($$v) {
                                _vm.$set(_vm.search_data, "nama_poli", $$v)
                              },
                              expression: "search_data.nama_poli",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "mt-3",
                      attrs: { id: "tabledata-kuota-poli" },
                    }),
                    _vm._v(" "),
                    _vm.table
                      ? _c("div", { staticClass: "row mt-5" }, [
                          _c("div", { staticClass: "col" }, [
                            _vm._v(
                              "\n                        Showing " +
                                _vm._s(_vm.paging_data.from) +
                                " to " +
                                _vm._s(_vm.paging_data.to) +
                                " of " +
                                _vm._s(_vm.paging_data.total) +
                                " entries\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col" },
                            [
                              _vm.total_rows > 0
                                ? _c("b-pagination", {
                                    attrs: {
                                      "per-page": _vm.item_per_page,
                                      "total-rows": _vm.total_rows,
                                      "prev-text": "Prev",
                                      "next-text": "Next",
                                      align: "center",
                                    },
                                    on: { "page-click": _vm.pageClick },
                                    model: {
                                      value: _vm.page,
                                      callback: function ($$v) {
                                        _vm.page = $$v
                                      },
                                      expression: "page",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              ref: "modal-umum",
              attrs: {
                id: "modal-umum",
                title: "Tambah Poli umum",
                tabindex: "-1",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "modal-footer",
                    fn: function () {
                      return [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "danger" },
                            on: { click: _vm.cancelModal },
                          },
                          [_vm._v("Batal")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "success" },
                            on: { click: _vm.submitModalDokter },
                          },
                          [_vm._v("Simpan")]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                2373640805
              ),
            },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-md-4 text-end col-form-label",
                    attrs: { for: "modal-poli" },
                  },
                  [_vm._v("Pilih Poli")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("select2", {
                      attrs: {
                        options: _vm.all_poli_options,
                        id: "modal-poli",
                        container: "modal-umum",
                      },
                      on: { change: _vm.getModalDokter },
                      model: {
                        value: _vm.create_data.kode_poli,
                        callback: function ($$v) {
                          _vm.$set(_vm.create_data, "kode_poli", $$v)
                        },
                        expression: "create_data.kode_poli",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-md-4 text-end col-form-label",
                    attrs: { for: "modal-dokter" },
                  },
                  [_vm._v("Pilih Dokter")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("select2", {
                      attrs: {
                        options: _vm.dokter_poli_options,
                        id: "modal-dokter",
                      },
                      model: {
                        value: _vm.create_data.kode_dokter,
                        callback: function ($$v) {
                          _vm.$set(_vm.create_data, "kode_dokter", $$v)
                        },
                        expression: "create_data.kode_dokter",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-md-4 text-end col-form-label",
                    attrs: { for: "modal-hari" },
                  },
                  [_vm._v("Pilih Hari")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("select2", {
                      attrs: { options: _vm.hari_options, id: "modal-hari" },
                      model: {
                        value: _vm.create_data.hari,
                        callback: function ($$v) {
                          _vm.$set(_vm.create_data, "hari", $$v)
                        },
                        expression: "create_data.hari",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }